import { IntegrationsSettings } from './integrations-settings';

export { IntegrationsSettings };
